import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   isKeepArchived: false,
   isNotificationsEnabled: false,
};

const settingsSlice = createSlice({
   name: 'settingsData',
   initialState,
   reducers: {
      setKeepArchived(state, action) {
         state.isKeepArchived = action.payload;
      },
      setNotificationsEnabled(state, action) {
         state.isNotificationsEnabled = action.payload;
      },
   },
});

export const { setKeepArchived, setNotificationsEnabled } = settingsSlice.actions;

export const settingsReducers = {
   settingsData: settingsSlice.reducer,
};
export default settingsSlice;
